<template>
  <div class="container" @scroll="handleScroll">
    <div class="scrollBox" ref="content">
      <slot></slot>
    </div>
    <div
      class="scorll-box"
      :style="{
        '--scrollwidth': scrollwidth + 'rem',
        '--scrollHeight': scrollHeight + 'rem',
        '--scrollColor': scrollColor,
      }"
    >
      <div
        class="scorll-block"
        :style="{
          '--blockwidth': blockwidth + 'rem',
          '--blockColor': blockColor,
          '--box-left': this.scroll + 'px',
        }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "scrollwidth",
    "scrollHeight",
    "scrollColor",
    "blockwidth",
    "blockColor",
    "step",
  ],
  data() {
    return {
      scroll: 0,
    };
  },
  computed: {
    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  methods: {
    handleScroll() {
      let dom = this.$refs.content.getBoundingClientRect();

      let left = Math.abs(parseInt(dom.x)) / this.step;
      if (left >= 1) {
        this.scroll = left;
      } else {
        this.scroll = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  overflow-x: auto;

  .scrollBox {
    display: flex;
  }
  &::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .scorll-box {
    position: absolute;
    left: 50%;
    display: none;
    transform: translate(-50%, 0px);
    width: var(--scrollwidth);
    height: var(--scrollHeight);
    background: var(--scrollColor);
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: var(--blockwidth);
      height: 100%;
      background: var(--blockColor);
      border-radius: 3px;
    }
  }
}
</style>
